import { render, staticRenderFns } from "./MenuPaquetes.vue?vue&type=template&id=088aca56&scoped=true"
import script from "./MenuPaquetes.vue?vue&type=script&lang=js"
export * from "./MenuPaquetes.vue?vue&type=script&lang=js"
import style0 from "./MenuPaquetes.vue?vue&type=style&index=0&id=088aca56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088aca56",
  null
  
)

export default component.exports